export default {"forgotPasswordForm":"_3uZ99","helperText":"vulvr","buttonSection":"CdHYE","responseMessage":"v-zd6","errorMessage":"ECtPG"};